/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendNotificationRequest
 */
export interface MailBankSendNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankSendNotificationRequest
     */
    courierId: string;
    /**
     * 
     * @type {string}
     * @memberof MailBankSendNotificationRequest
     */
    notification: string;
    /**
     * 
     * @type {string}
     * @memberof MailBankSendNotificationRequest
     */
    recipientType: string;
}

/**
 * Check if a given object implements the MailBankSendNotificationRequest interface.
 */
export function instanceOfMailBankSendNotificationRequest(value: object): value is MailBankSendNotificationRequest {
    if (!('courierId' in value) || value['courierId'] === undefined) return false;
    if (!('notification' in value) || value['notification'] === undefined) return false;
    if (!('recipientType' in value) || value['recipientType'] === undefined) return false;
    return true;
}

export function MailBankSendNotificationRequestFromJSON(json: any): MailBankSendNotificationRequest {
    return MailBankSendNotificationRequestFromJSONTyped(json, false);
}

export function MailBankSendNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'],
        'notification': json['notification'],
        'recipientType': json['recipientType'],
    };
}

export function MailBankSendNotificationRequestToJSON(json: any): MailBankSendNotificationRequest {
    return MailBankSendNotificationRequestToJSONTyped(json, false);
}

export function MailBankSendNotificationRequestToJSONTyped(value?: MailBankSendNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'notification': value['notification'],
        'recipientType': value['recipientType'],
    };
}

